<template>
  <div class="ComBackIcon" @click="clickHandle">
    <span class="fa fa-angle-left centerposition iconSpan"></span>
  </div>
</template>

<script>
    export default{
      props:{
        backData:{
          type:String,
          default:'0'
        },

      },
      methods:{
        clickHandle(){
          if(this.backData=='0'){
            this.$router.go(-1);
          }else{
            this.$router.push(this.backData);
          }
        }
      }
    }
</script>

<style lang="scss">
  .ComBackIcon{
    position: fixed;
    z-index: 30;
    left:$commonP;
    bottom: 120px;
    background: rgba(0,0,0,0.5);
    border-radius: 100px;
    width: 80px;
    height: 80px;
    .iconSpan{
      font-size: 60px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BackIcon/index.vue